const ProductDetailVariants = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_ProductVariantColors: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'productVariantColors',
        },
        options: {
          colorVariant_TitleText: {
            type: 'Text',
            order: 0,
          },
          colorVariant_TitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          colorVariant_TitleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_TitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 1,
          },
          colorVariant_TitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 1,
          },
          colorVariant_TitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 1,
          },
          colorVariant_BoxesPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 1,
          },
          colorVariant_BoxesWidth: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          colorVariant_BoxesHeight: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          colorVariant_BoxesBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 1,
          },
          colorVariant_DefaultVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DefaultTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DefaultTextBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedTextBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DisplayMode: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['slide', 'grid'],
            },
          },
          colorVariant_ImageType: {
            type: 'SelectBox',
            data: {
              selectOptions: ['image', 'color', 'text'],
            },
            order: 1,
          },
          colorVariant_ShowVariantTitle: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          colorVariant_VariantTitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          colorVariant_VariantTitleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_VariantTitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 1,
          },
          colorVariant_VariantTitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 1,
          },
          colorVariant_VariantTitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 1,
          },
        },
      },
      Menu_ProductVariantSizes: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'productVariantSizes',
        },
        options: {
          textVariant_TitleText: {
            type: 'Text',
            order: 0,
          },
          textVariant_TitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          textVariant_TitleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_TitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 1,
          },
          textVariant_TitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 1,
          },
          textVariant_TitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 1,
          },
          textVariant_BoxesPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 1,
          },
          textVariant_BoxesWidth: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          textVariant_BoxesHeight: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          textVariant_BoxesBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 1,
          },
          textVariant_DefaultVariantBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DefaultVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DefaultVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DisplayMode: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['slide', 'grid'],
            },
          },
          isShowLastProduct: {
            type: 'Toggle',
            order: 100,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'Variants_1',
      name: 'Variants_1',
      type: 'ProductDetailVariants',
      data: {
        textVariant_TitleText: '',
        colorVariant_TitleText: '',
      },
      customization: {
        colorVariant_ImageType: 'image',
        textVariant_BoxesWidth: '60px',
        colorVariant_BoxesWidth: '45px',
        textVariant_BoxesHeight: '36px',
        textVariant_DisplayMode: 'slide',
        colorVariant_BoxesHeight: '45px',
        colorVariant_DisplayMode: 'slide',
        textVariant_BoxesPadding: '0px 0px 0px 0px',
        colorVariant_BoxesPadding: '0px 0px 0px 0px',
        textVariant_TitleTextSize: '6px',
        colorVariant_TitleTextSize: '7px',
        textVariant_TitleTextColor: '#000',
        textVariant_TitleTextStyle: 'normal',
        colorVariant_TitleTextColor: '#969696',
        colorVariant_TitleTextStyle: 'normal',
        textVariant_TitleTextWeight: '400',
        colorVariant_TitleTextWeight: '400',
        colorVariant_DefaultTextColor: '#000000',
        colorVariant_ShowVariantTitle: 'show',
        textVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_SelectedTextColor: '#000',
        textVariant_TitleTextAlignment: 'left',
        colorVariant_TitleTextAlignment: 'left',
        colorVariant_VariantTitleTextSize: '9px',
        colorVariant_VariantTitleTextColor: '#000',
        colorVariant_VariantTitleTextStyle: 'normal',
        colorVariant_VariantTitleTextWeight: '400',
        textVariant_DefaultVariantTextColor: '#000000',
        textVariant_SelectedVariantTextColor: '#000000',
        textVariant_DefaultVariantBorderColor: '#e0e0e0',
        colorVariant_DefaultVariantBorderColor: '#d6d6d6',
        colorVariant_VariantTitleTextAlignment: 'center',
        textVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_DefaultTextBackgroundColor: '#ffffff',
        colorVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_SelectedTextBackgroundColor: '#242424',
        textVariant_DefaultVariantBackgroundColor: '#ffffff',
        textVariant_SelectedVariantBackgroundColor: '#ffffff',
        isShowLastProduct: true,
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Variants_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default ProductDetailVariants;
